<template>
  <div class="k-page-content">
    <div class="k-home-index">
      <div class="k-home-nav">
        <a>
          <div class="k-home-nav-box k-role-info">
            <div class="k-role-info-box">
              <div class="flex-row-center">
                <div class="avatar-wrapper">
                  <img src="../assets/images/admin.png" alt />
                </div>
              </div>
              <div class="desc-wrapper">
                <span>{{userInfo.nickname}}</span>
                <span>{{userInfo.email}}</span>
                <span>部门经理</span>
              </div>
            </div>
          </div>
        </a>
        <a>
          <div class="k-home-nav-box">
            <div class="k-box-t">
              <span>{{userInfo.advertisersTotal}}</span>
              <span>个</span>
            </div>
            <div class="k-box-b">媒体账户</div>
          </div>
        </a>
        <a>
          <div class="k-home-nav-box">
            <div class="k-box-t">
              <span>{{userInfo.adNewTotal}}</span>
              <span>条</span>
            </div>
            <div class="k-box-b">今日新建计划</div>
          </div>
        </a>
        <a>
          <div class="k-home-nav-box">
            <div class="k-box-t">
              <span>{{userInfo.adDenyTotal}}</span>
              <span>条</span>
            </div>
            <div class="k-box-b">今日被拒计划</div>
          </div>
        </a>
      </div>
      <div class="k-home-title">
        <div class="k-home-title-top">
          <div class="item1">
            <h5>整体数据概览</h5>
            <!-- <a href="###">查看详情</a> -->
          </div>
          <div class="item2">
            <el-select
              v-model="dataValue"
              placeholder="请选择"
              :size="size"
              style="width:100px"
              @change="getCostMethod"
            >
              <el-option
                v-for="item in dataOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="k-home-title-box">
          <div class="item">
            <div class="item-left">
              <img src="../assets/images/icon1.png" alt />
            </div>
            <div class="item-right">
              <div class="t1">消耗（元）</div>
              <div class="t2">{{getCostInfo.stat_cost_total}}</div>
              <div class="t3">
                较上周期
                <template v-if="getCostInfo.stat_cost_total_huanbi< 0">
                  <img src="../assets/images/down.png" alt />
                  <span class="green">{{getCostInfo.stat_cost_total_huanbi}}%</span>
                </template>
                <template v-if="getCostInfo.stat_cost_total_huanbi >= 0">
                  <img src="../assets/images/up.png" alt />
                  <span class="red">{{getCostInfo.stat_cost_total_huanbi}}%</span>
                </template>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <img src="../assets/images/icon2.png" alt />
            </div>
            <div class="item-right">
              <div class="t1">点击率</div>
              <div class="t2">{{getCostInfo.ctr_total/100}}%</div>
              <div class="t3">
                较上周期
                <template v-if="getCostInfo.ctr_total_huanbi< 0">
                  <img src="../assets/images/down.png" alt />
                  <span class="green">{{getCostInfo.ctr_total_huanbi}}%</span>
                </template>
                <template v-if="getCostInfo.ctr_total_huanbi >= 0">
                  <img src="../assets/images/up.png" alt />
                  <span class="red">{{getCostInfo.ctr_total_huanbi}}%</span>
                </template>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <img src="../assets/images/icon3.png" alt />
            </div>
            <div class="item-right">
              <div class="t1">成交订单数</div>
              <div class="t2">{{getCostInfo.pay_order_count_total}}</div>
              <div class="t3">
                较上周期
                <template v-if="getCostInfo.pay_order_count_total_huanbi< 0">
                  <img src="../assets/images/down.png" alt />
                  <span class="green">{{getCostInfo.pay_order_count_total_huanbi}}%</span>
                </template>
                <template v-if="getCostInfo.pay_order_count_total_huanbi >= 0">
                  <img src="../assets/images/up.png" alt />
                  <span class="red">{{getCostInfo.pay_order_count_total_huanbi}}%</span>
                </template>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <img src="../assets/images/icon4.png" alt />
            </div>
            <div class="item-right">
              <div class="t1">成交订单金额（元）</div>
              <div class="t2">{{getCostInfo.pay_order_amount_total}}</div>
              <div class="t3">
                较上周期
                <template v-if="getCostInfo.pay_order_amount_total< 0">
                  <img src="../assets/images/down.png" alt />
                  <span class="green">{{getCostInfo.pay_order_amount_total}}%</span>
                </template>
                <template v-if="getCostInfo.pay_order_amount_total >= 0">
                  <img src="../assets/images/up.png" alt />
                  <span class="red">{{getCostInfo.pay_order_amount_total}}%</span>
                </template>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <img src="../assets/images/icon5.png" alt />
            </div>
            <div class="item-right">
              <div class="t1">支付ROI（原成交ROI）</div>
              <div class="t2">{{getCostInfo.prepay_and_pay_order_roi_total}}</div>
              <div class="t3">
                较上周期
                <template v-if="getCostInfo.prepay_and_pay_order_roi_total_huanbi< 0">
                  <img src="../assets/images/down.png" alt />
                  <span class="green">{{getCostInfo.prepay_and_pay_order_roi_total_huanbi}}%</span>
                </template>
                <template v-if="getCostInfo.prepay_and_pay_order_roi_total_huanbi >= 0">
                  <img src="../assets/images/up.png" alt />
                  <span class="red">{{getCostInfo.prepay_and_pay_order_roi_total_huanbi}}%</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="k-home-data">
        <div class="k-home-title-top">
          <div class="item1">
            <h5>整体数据概览</h5>
            <!-- <a href="###">查看详情</a> -->
          </div>
          <div class="item2">
            <el-select
              v-model="dataValue2"
              placeholder="请选择"
              :size="size"
              style="width:100px"
              @change="getEchartData"
            >
              <el-option
                v-for="item in dataOptions2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="k-home-data-filter">
          <div>
            <el-select v-model="dataValue3" placeholder="请选择" :size="size" @change="getEchartData">
              <el-option
                v-for="item in dataOptions3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-checkbox v-model="vs" style="margin:0 20px;" @click="duibiClick">对比</el-checkbox>
            <el-select
              v-model="dataValue4"
              v-if="vs"
              placeholder="请选择"
              :size="size"
              @change="getEchartData"
            >
              <el-option
                v-for="item in dataOptions4"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div>
            <el-select v-model="dataValue5" placeholder="请选择" :size="size" @change="getEchartData">
              <el-option
                v-for="item in dataOptions5"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="k-home-data-con">
          <div id="main" style="width: 100%;height:400px;"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    return {
      activeName: 'first',
      bodyStyle: {
        padding: '20px',
        height: '140px',
        'background-color': '#409EFF',
        color: '#FFFFFF',
        'text-align': 'center'
      },
      chartInst: {},
      userInfo: {
        nickname: '',
        email: '',
        advertisersTotal: '',
        adNewTotal: '',
        adDenyTotal: ''
      },
      getCostInfo: {
        stat_cost_total: 0,
        ctr_total: 0,
        pay_order_count_total: 0,
        pay_order_amount_total: 0,
        prepay_and_pay_order_roi_total: 0,
        stat_cost_total_huanbi: 0,
        ctr_total_huanbi: 0,
        pay_order_count_total_huanbi: 0,
        pay_order_amount_total_huanbi: 0,
        prepay_and_pay_order_roi_total_huanbi: 0
      },
      tableData: {},
      size: 'mini',
      dataOptions: [
        {
          value: '1',
          label: '今天'
        },
        {
          value: '2',
          label: '昨天'
        },
        {
          value: '3',
          label: '过去7天'
        },
        {
          value: '4',
          label: '过去30天'
        }
      ],
      dataValue: '1',
      dataOptions2: [
        {
          value: '1',
          label: '过去7天'
        },
        {
          value: '2',
          label: '过去30天'
        }
      ],
      dataValue2: '1',
      vs: false,
      dataOptions3: [
        {
          value: '1',
          label: '消耗(元)'
        },
        {
          value: '2',
          label: '成交订单数'
        },
        {
          value: '3',
          label: '成交订单金额(元)'
        },
        {
          value: '4',
          label: '支付ROI(原成交ROI)'
        }
      ],
      dataValue3: '1',
      dataOptions4: [
        {
          value: '1',
          label: '消耗(元)'
        },
        {
          value: '2',
          label: '成交订单数'
        },
        {
          value: '3',
          label: '成交订单金额(元)'
        },
        {
          value: '4',
          label: '支付ROI(原成交ROI)'
        }
      ],
      dataValue4: '0',
      dataOptions5: [
        {
          value: '1',
          label: '全部账户'
        },
        {
          value: '2',
          label: 'Top5账户'
        },
        {
          value: '3',
          label: 'Top10账户'
        }
      ],
      dataValue5: '1'
    }
  },
  computed: {
    tableHeight: function() {
      return window.innerHeight - 425
    }
  },
  methods: {
    duibiClick: function() {
      console.log(this.vs)
    },
    getMainInfo: function() {
      this.$api.http.get('index/mainInfo', {}).then(res => {
        if (res.code === 0) {
          var data = res.data
          this.userInfo.nickname = data.userInfo.nickname
          this.userInfo.email = data.userInfo.email
          this.userInfo.advertisersTotal = data.totalInfo.advertisersTotal
          this.userInfo.adNewTotal = data.totalInfo.adNewTotal
          this.userInfo.adDenyTotal = data.totalInfo.adDenyTotal
        }
      })
    },
    getCostMethod: function() {
      this.$api.http
        .get('index/getCost', {
          type: this.dataValue
        })
        .then(res => {
          if (res.code === 0) {
            var data = res.data
            this.getCostInfo = data
          }
        })
    },
    options(title, legend, xAxisData, seriesData) {
      let series = []
      // 指定图表的配置项和数据
      for (let i = 0; i < legend.length; i++) {
        series.push({
          name: legend[i],
          type: 'line',
          stack: 'Total' + i,
          data: seriesData[i]
        })
      }

      var option = {
        title: {
          text: title
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legend
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: series
      }
      return option
    },

    getEchartData: function() {
      var isTop = this.dataValue5
      if (isTop != 1) {
        this.vs = false
        this.dataValue4 = 0
      }
      this.$api.http
        .get('index/getChartInfo', {
          type: this.dataValue3,
          type2: this.dataValue4,
          timeType: this.dataValue2,
          isTop: this.dataValue5
        })
        .then(res => {
          if (res.code === 0) {
            var data = res.data
            var options = this.options(
              data.title,
              data.legend,
              data.xAxisData,
              data.seriesData
            )
            document
              .getElementById('main')
              .setAttribute('_echarts_instance_', '')

            this.chartInst.setOption(options, !0, !0)
          }
        })
    }
  },
  mounted: function() {
    this.getMainInfo()
    this.getCostMethod()
    this.chartInst = this.$echarts.init(document.getElementById('main'))
    this.getEchartData()
  }
}
</script>
<style scoped>
.k-home-index {
  height: 100%;
  width: 100%;
  overflow: auto;
}

.k-home-nav {
  margin: 16px 16px 0;
  background: #fff;
  display: flex;
}

.k-home-nav a {
  cursor: pointer;
  display: inline-block;
  width: 23%;
}

.k-home-nav a:nth-child(1) {
  width: 31%;
}

.k-home-nav-box {
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
  height: 104px;
  padding: 24px 24px 0;
  background: #fff;
}

.k-home-nav-box:hover {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08);
}

.k-home-nav-box:hover:before {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  display: block;
  height: 4px;
  cursor: pointer;
  content: '';
  background: #3aa0ff;
  border-radius: 2px 2px 0 0;
}

.k-home-nav-box .k-box-t {
  margin: 2px 0 16px;
  display: flex;
  align-items: flex-end;
}

.k-home-nav-box .k-box-t span:nth-child(1) {
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
  color: #333;
}

.k-home-nav-box .k-box-t span:nth-child(2) {
  margin-left: 8px;
  font-size: 14px;
  color: #333;
}

.k-home-nav-box .k-box-b {
  color: #197afb;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.flex-row-center .avatar-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  margin-right: 16px;
}

.flex-row-center .avatar-wrapper img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.k-role-info-box .desc-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
}

.k-role-info-box .desc-wrapper span {
  font-size: 14px;
  color: #333;
  line-height: 14px;
}

.k-role-info-boxr .desc-wrapper span:nth-child(1) {
  font-weight: bold;
}

.k-role-info-box .desc-wrapper span:nth-child(2) {
  margin: 8px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 16px;
}

.k-role-info-box .desc-wrapper span:nth-child(3) {
  font-size: 12px;
  color: rgb(102, 102, 102);
}

.k-role-info-box {
  display: flex;
  align-items: center;
}

.k-home-title {
  margin: 16px 16px 0;
  background: #fff;
  padding: 24px 24px 40px;
  background: #fff;
  border-radius: 2px;
}

.k-home-title-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.k-home-title-top div {
  display: flex;
  align-items: center;
}

.k-home-title-top .item1 h5 {
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  color: #333;
}

.k-home-title-top .item1 a {
  font-size: 12px;
  line-height: 12px;
  color: #197afb;
  margin-left: 16px;
}

.k-home-title-box {
  display: flex;
  margin-top: 48px;
}

.k-home-title-box .item {
  position: relative;
  display: flex;
  flex-basis: 20%;
}

.k-home-title-box .item:not(:nth-last-child(1)):before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: block;
  width: 1px;
  content: '';
  background: #e8eaec;
}

.k-home-title-box .item .item-left {
  margin: 0 16px;
}

.k-home-title-box .item .item-right .t1 {
  font-size: 12px;
  color: #666;
}

.k-home-title-box .item .item-right .t2 {
  margin: 12px 0 32px;
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  color: #333;
}

.k-home-title-box .item .item-right .t3 {
  font-size: 12px;
  line-height: 12px;
  color: #999;
  display: flex;
  align-items: center;
}

.k-home-title-box .item .item-right .t3 img {
  margin: 0 0 0 4px;
}

.k-home-title-box .item .item-right .t3 .green {
  color: #23c23f;
}

.k-home-title-box .item .item-right .t3 .red {
  color: #f42828;
}

.k-home-data {
  margin: 16px 16px 0;
  background: #fff;
  padding: 24px 24px 40px;
  background: #fff;
  border-radius: 2px;
}

.k-home-data-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
}

.k-home-data-con {
  margin-top: 46px;
}
</style>
